export type ReferenceSplit = 'LINES' | 'PARAGRAPHS' | 'NUMBERED';

export function referencePreview(value: string, mode: ReferenceSplit): { records: string[]; error: string } {
  const text = value.replace(/\r\n?/g, '\n').trim();
  if (!text) return { records: [], error: '' };
  let records: string[] = [];
  if (mode === 'LINES') records = text.split('\n').map((line) => line.trim()).filter(Boolean);
  else if (mode === 'PARAGRAPHS') records = text.split(/\n[ \t]*\n+/).map((block) => block.split('\n').map((line) => line.trim()).filter(Boolean).join(' '));
  else {
    let parts: string[] = [], previous: number | null = null;
    for (const line of text.split('\n')) {
      if (!line.trim()) continue;
      const match = line.match(/^\s*(?:\[([0-9]{1,5})\]|([0-9]{1,5})[.)])(?:\s+|$)(.*)$/);
      if (match) {
        const number = Number(match[1] || match[2]);
        if (number < 1 || previous !== null && number !== previous + 1) return { records: [], error: 'Нумерация прерывается или повторяется. Исправьте номера либо разделите записи пустыми строками.' };
        if (previous !== null && !parts.length) return { records: [], error: 'После номера записи нет текста.' };
        if (parts.length) records.push(parts.join(' '));
        parts = match[3].trim() ? [match[3].trim()] : [];
        previous = number;
      } else if (previous === null) return { records: [], error: 'Первая запись должна начинаться с 1., 1) или [1]. Уберите заголовок либо выберите другой способ разделения.' };
      else parts.push(line.trim());
    }
    if (!parts.length) return { records: [], error: 'После номера записи нет текста.' };
    records.push(parts.join(' '));
  }
  if (records.length > 50 || text.length > 40000) return { records: [], error: 'До 50 записей и 40 000 символов за запуск. Разделите список.' };
  return { records, error: '' };
}
